module.exports = __webpack_public_path__ + "img/4.d4e395cb.png";